import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { c as createPopper, o as offset } from './popper-lite.js';

const dropdownMenuCss = ":host{font-family:var(--font-family-body, \"Inter\", sans-serif)}.wrapper{position:relative;display:none;z-index:var(--z-index-popover, 9100)}.wrapper.show{display:flex}.wrapper .list-container{position:relative;min-width:var(--hmc-dropdown-menu-min-width, 220px);max-width:var(--hmc-dropdown-menu-max-width, 220px);display:flex;flex-direction:column;gap:6px;padding:6px 4px;border-radius:8px;border:1px solid var(--hmc-color-layout-divider-default, var(--hmc-color-gray-300, #b7bbc3));box-shadow:0px 5px 5px 0px rgba(34, 37, 47, 0.1), 0px 0px 5px 0px rgba(34, 37, 47, 0.1);background-color:var(--hmc-color-layout-container, var(--hmc-color-gray-white, #fff));min-height:16px}";

const HmcDropdownMenu$1 = /*@__PURE__*/ proxyCustomElement(class HmcDropdownMenu extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.handleMenu = () => {
      if (this.isOpen) {
        const xoffset = this.alignment === 'right' ? 4 : this.alignment === 'left' ? -4 : 0;
        const yoffset = 4;
        this.menuInstance = createPopper(this.triggerElement, this.menuEl, {
          placement: this.placement,
          strategy: 'absolute',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, yoffset],
              },
            },
            {
              name: 'computeStyles',
              options: {
                gpuAcceleration: false,
              },
            },
            {
              name: 'applyAlignment',
              enabled: true,
              phase: 'write',
              fn: ({ state }) => {
                const alignment = this.alignment;
                state.elements.popper.setAttribute('data-align', alignment);
              },
            },
            {
              name: 'anchor',
              enabled: true,
              phase: 'beforeWrite',
              fn: ({ state }) => {
                if (this.alignment === 'right') {
                  state.styles.popper.left = `${state.rects.reference.x +
                    state.rects.reference.width +
                    xoffset}px`;
                  state.styles.popper.transform = `translateX(-100%)`;
                }
                else {
                  state.styles.popper.left = `${state.rects.reference.x + xoffset}px`;
                  state.styles.popper.transform = `translateX(0)`;
                }
              },
            },
            offset,
          ],
        });
        requestAnimationFrame(() => {
          this.menuInstance.update();
        });
      }
      else if (this.menuInstance) {
        this.menuInstance.destroy();
        this.menuInstance = null;
      }
    };
    this.triggerId = undefined;
    this.isOpen = false;
    this.placement = 'bottom';
    this.alignment = 'left';
  }
  updateOnTriggerIdChange() {
    this.selectMenuTarget();
  }
  componentDidLoad() {
    this.selectMenuTarget();
    if (this.triggerElement) {
      this.triggerElement.addEventListener('click', ev => {
        ev.stopPropagation();
        this.isOpen = !this.isOpen;
        this.handleMenu();
      });
    }
  }
  selectMenuTarget() {
    var _a;
    if (this.triggerId !== '') {
      const rootElement = this.el.getRootNode();
      this.triggerElement =
        (_a = document.getElementById(this.triggerId)) !== null && _a !== void 0 ? _a : rootElement.querySelector(`#${this.triggerId}`);
    }
  }
  render() {
    const { isOpen } = this;
    const wrapperClasses = {
      wrapper: true,
      show: isOpen,
    };
    const listContainerClasses = {
      'list-container': true,
      'show': isOpen,
    };
    return (h(Host, { role: "menu" }, h("div", { ref: ref => (this.menuEl = ref), class: wrapperClasses }, h("div", { class: listContainerClasses }, h("slot", null)))));
  }
  get el() { return this; }
  static get watchers() { return {
    "triggerId": ["updateOnTriggerIdChange"]
  }; }
  static get style() { return dropdownMenuCss; }
}, [1, "hmc-dropdown-menu", {
    "triggerId": [1, "trigger-id"],
    "isOpen": [4, "open"],
    "placement": [1],
    "alignment": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["hmc-dropdown-menu"];
  components.forEach(tagName => { switch (tagName) {
    case "hmc-dropdown-menu":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, HmcDropdownMenu$1);
      }
      break;
  } });
}

const HmcDropdownMenu = HmcDropdownMenu$1;
const defineCustomElement = defineCustomElement$1;

export { HmcDropdownMenu, defineCustomElement };
